import { render } from "./ViewRecruiter.vue?vue&type=template&id=16461d5a&scoped=true"
import script from "./ViewRecruiter.vue?vue&type=script&lang=js"
export * from "./ViewRecruiter.vue?vue&type=script&lang=js"

import "./ViewRecruiter.vue?vue&type=style&index=0&id=16461d5a&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16461d5a"]])

export default __exports__